import { ChangeEventHandler, FocusEventHandler, forwardRef } from 'react';
import { TextField } from '@material-ui/core';
import { HelperText } from '../../HelperText/HelperText';
import useStyles from './useStyles';
import InputContainer from '../../InputContainer/InputContainer';

interface Props {
  title?: string;
  isSubField?: boolean;
  placeHolder: string;
  value: string;
  error?: string;
  validation?: (value: string) => boolean;
  onValidationChanged?: (isValid: boolean) => void;
  onValueChanged: (value: string) => void;
  ref?: any;
  autoComplete?: string;
  className?: string;
  onBlur?: () => void;
}

export type TextInputComponent = React.FC<Props>;

const TextInput: TextInputComponent = forwardRef((props, ref) => {
  const {
    isSubField,
    validation = () => true,
    onValidationChanged = () => {},
    onValueChanged = () => {},
    error,
    onBlur = () => {},
  } = props;

  const classes = useStyles(isSubField);

  const renderTextField = () => {
    const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
      const value = e.target.value;
      const isValid = validation(value);
      onValidationChanged(isValid);
      onValueChanged(value);
      if (e.type === 'blur') {
        onBlur();
      }
    };

    return (
      <TextField
        autoComplete={`${props.autoComplete ? props.autoComplete : 'off'}`}
        inputRef={ref}
        id={props.title}
        variant="outlined"
        fullWidth={!props.isSubField}
        className={`${classes.input} ${props.className}`}
        inputProps={{
          value: props.value,
          maxLength: 100,
        }}
        placeholder={props.placeHolder}
        onChange={onChange}
        onBlur={onChange as FocusEventHandler<HTMLInputElement>}
        error={error !== undefined && error !== ''}
        helperText={<>{error && !isSubField && <HelperText error={error} />}</>}
      />
    );
  };

  return (
    <InputContainer
      title={props.title}
      isSubField={props.isSubField}
      error={props.error}
    >
      {renderTextField()}
    </InputContainer>
  );
});

export default TextInput;
